import React from "react"

export interface CriteoUser {
  email?: string
}

const getDataLayer = () => {
  const _window = typeof window !== "undefined" && (window as any)
  if (_window) {
    return _window.dataLayer || []
  }
}

export default () => {
  const dataLayer = getDataLayer()

  const criteoOnUserData = React.useCallback(
    (user: CriteoUser) => {
      if (dataLayer) {
        if (user.email) {
          dataLayer.push({
            uid: {
              email: user.email,
            },
          })
        }
      }
    },
    [dataLayer]
  )

  const criteoOnZipCode = React.useCallback(
    (zipCode: string) => {
      if (dataLayer) {
        dataLayer.push({
          uid: {
            zipcode: zipCode,
          },
        })
      }
    },
    [dataLayer]
  )

  const criteoOnKeywords = React.useCallback(
    (keywords: string) => {
      if (dataLayer) {
        dataLayer.push({
          uid: {
            keywords,
          },
        })
      }
    },
    [dataLayer]
  )

  return {
    criteoOnUserData,
    criteoOnZipCode,
    criteoOnKeywords,
  }
}
